import { useQuery } from '@tanstack/react-query'
import { meQueryKey, meQueryOptions } from '@/shared/api/meQueries'
import { useBeneficiariesList as useSharedBeneficiariesList, beneficiariesKeys } from '@/shared/api/beneficiariesQueries'

export { meQueryKey } from '@/shared/api/meQueries'
export type { UserProfileData } from '@/shared/schemas/meApi.schema'

export const profileKeys = {
  all: ['profile'] as const,
  me: () => meQueryKey,
  beneficiaries: () => beneficiariesKeys.list(),
  points: () => [...profileKeys.all, 'points'] as const,
  tags: () => [...profileKeys.all, 'tags'] as const,
}

export function useMeProfile() {
  return useQuery(meQueryOptions)
}

export function useBeneficiariesList() {
  return useSharedBeneficiariesList()
}
